import { Props_SnippetImageContentCTA } from './ImageContentCTA.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'

const SnippetImageContentCTA = (props: Props_SnippetImageContentCTA) => {
    const { heading, image, content, repeatable_link } = props

    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-content-column__heading--${heading.visibility.value}` : ''

    return (
    <section className={`snippet-image-content-cta`}>
        <div className="snippet-image-content-cta__container">
            <div className="snippet-image-content-cta__container-image">
                <img
                    loading="lazy"
                    src={image.src?.value}
                    className="snippet-image-content-cta__image"
                    height={290}
                    width={1920}
                    alt={image.alt?.value ? image.alt.value : ''}
                />
            </div>
            <div className="snippet-image-content-cta__container-content">
                <div className="snippet-image-content-cta__content">
                    <h2 className={`snippet-image-content-cta__heading ${classHeadingVisibility}`}>{heading.content?.value}</h2>
                    {content.content?.value && <div className="snippet-image-content-cta__content">{CompileMarkdown(content.content?.value)}</div>}
                </div>
               <div className={`snippet-image-content-cta__container-button`}>
                    { repeatable_link.map((link, index) => (
                        <div key={index + (link.linkHref?.value || '')} className="snippet-image-content-cta__link">
                            <SnippetLink 
                                linkStyles={link.linkStyle?.value} 
                                className="snippet-image-content-cta__link" 
                                url={link.linkHref?.value} 
                                target={link.linkTarget?.value}
                            >
                                {link.linkContent?.value}
                            </SnippetLink>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </section>
    )
}

export default SnippetImageContentCTA